import { CSSObject } from '@chakra-ui/react';

export const TextTitle: CSSObject = {
  color: 'alpha.700',
};
